import { render } from "./TimestampTags.vue?vue&type=template&id=3c3103ba"
import script from "./TimestampTags.vue?vue&type=script&lang=js"
export * from "./TimestampTags.vue?vue&type=script&lang=js"

import "./TimestampTags.vue?vue&type=style&index=0&id=3c3103ba&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__